import React from 'react'

/** 6-digit authenticator code field (numeric keypad on phones, paste-friendly). */
const CodeInput: React.FC<{ value: string; onChange: (v: string) => void; autoFocus?: boolean; disabled?: boolean }> = ({
  value,
  onChange,
  autoFocus,
  disabled,
}) => (
  <input
    value={value}
    onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 6))}
    inputMode="numeric"
    autoComplete="one-time-code"
    autoFocus={autoFocus}
    disabled={disabled}
    placeholder="000000"
    maxLength={6}
    className="w-full px-4 py-3 text-center text-2xl font-mono tracking-[0.5em] border border-gray-200 rounded-xl bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
  />
)

export default CodeInput
